const checkInformationPerceptType = (type) => {
    return !['null', null, undefined, 'undefined', ''].includes(type);
};

export { checkInformationPerceptType };
